import { useQuery } from '@apollo/client/react'
import RoomMembers from '../graphql/queries/RoomMembers'
import useCurrentRoom from '../hooks/useCurrentRoom'
import ProfileAvatar from '../profile/ProfileAvatar'
import { Stack, Group, Text, Title, ScrollArea } from '@mantine/core'

export default function RoomMemberList() {
    const room = useCurrentRoom()
    const { data } = useQuery(RoomMembers, { skip: !room, variables: { roomId: room?.id } })
    const members = data?.room.members

    const lines =  members?.map( m => m)
        .sort( (a, b) => a.username < b.username ? -1 : 1 )
        .map( (member, index) =>
            <Group
                key={index}
                gap="sm"
                p="xs"
                style={{
                    backgroundColor: index % 2 === 0 ? 'rgba(255,255,255,0.03)' : 'transparent',
                    borderRadius: 4
                }}
            >
                <ProfileAvatar user={member} size={32} />
                <Text size="sm" style={{ flex: 1 }}>{ member.username }</Text>
            </Group>
        )

    return (
        <Stack gap={0}>
            <Title
                order={6}
                p="sm"
                style={{
                    borderBottom: '1px solid rgba(255,255,255,0.1)',
                    margin: 0
                }}
            >
                Room Members ({members?.length || 0})
            </Title>
            <ScrollArea h={300} type="auto">
                <Stack gap={0} p="xs">
                    { lines }
                </Stack>
            </ScrollArea>
        </Stack>
    )
}
